import React, { useState } from 'react';
import { AutoComplete } from 'rsuite';

import { useDebouncedCallback } from 'use-debounce/lib';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import api from '~/services/api';

function FiltroEstados({ onItemAdicionado, disabled, setFiltroCidades }) {
  const [estados, setEstados] = useState([]);
  const buscarEstados = useDebouncedCallback(async (texto) => {
    if (texto === '') setFiltroCidades([]);
    if (texto) {
      try {
        const resposta = await api.get('estado', {
          params: {
            nome: texto,
          },
        });
        setEstados(resposta.data);
      } catch (error) {
        toast.error(error.message);
      }
    }
  }, 500).callback;

  return (
    <AutoComplete
      data={estados
        .map((c) => ({
          label: c.estado,
          value: c.estado,
          id: c.id,
          uf: c.uf,
        }))
        .slice(0, 10)}
      onSelect={onItemAdicionado}
      onChange={buscarEstados}
      placeholder="Estados"
      disabled={disabled}
    />
  );
}

FiltroEstados.propTypes = {
  onItemAdicionado: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  setFiltroCidades: PropTypes.func,
};

FiltroEstados.defaultProps = {
  disabled: false,
  setFiltroCidades: () => {},
};

export default FiltroEstados;
